<p 
    style="text-align: center;
    padding: 1rem 0px 0px 0px !important;
    font-size: 16px;">
    <!-- {{ 'GENERAL.LICENSE_FOR' | transloco: { companyName: companyName | transloco } }} -->
</p>